
<ng-container *ngFor="let alert of alerts">
    <!-- <div class="{{cssClass(alert)}} py-0" *ngIf="!(mainScreen && alert.hideOnMainScreen)"  [ngClass]="alert.hideOnMainScreen !== false ? 'my-0' : ''"> -->
        <div class="{{cssClass(alert)}} py-0" *ngIf="!(mainScreen && alert.hideOnMainScreen)">
        <span [innerHTML]="alert.message"></span>
        <a class="close " role="button" (click)="removeAlert(alert)">&times;</a>
    </div>
</ng-container>
